import { HttpResponse } from '@angular/common/http';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { AgenciasService } from 'src/app/_services/agencias.service';
import { AuxiliarService } from 'src/app/_services/auxiliar.service';
import { ToursService } from 'src/app/_services/tours.service';
import { ModalConfirmComponent } from '../modal-confirm/modal-confirm.component';
import { ModalMsgComponent } from '../modal-msg/modal-msg.component';
import { ModalConfirmPasajeroDeleteComponent } from '../modal-confirm-pasajero-delete/modal-confirm-pasajero-delete.component';

@Component({
  selector: 'app-tour-agencias-confirmadas-detalle',
  templateUrl: './tour-agencias-confirmadas-detalle.component.html',
  styleUrls: ['./tour-agencias-confirmadas-detalle.component.css']
})
export class TourAgenciasConfirmadasDetalleComponent implements OnInit, OnDestroy {
  idPaquete: Number;
  idPasajero: Number;
  idAgencia: Number;
  listaReservaciones = [];
  idReservacion: Number;
  agenciaDatos = [];
  cantidadReservaciones: number;
  subscription: Subscription;
  subscriptionAg: Subscription;
  subscriptionPlanilla: Subscription;
  idPaquetePasajero: Number;
  subscriptionPas: Subscription;
  filtered: Object[];
  listapasajeros = [];
  form: FormGroup;

  constructor(
    private modalService: NgbModal,
    private agenciasService:AgenciasService,
    private formBuilder: FormBuilder,
    private tourservice: ToursService,
    private router: Router,
    private auxService:AuxiliarService,
  ) { }
  ngOnDestroy(): void {
    //throw new Error('Method not implemented.');
    this.subscription.unsubscribe();
    this.subscriptionAg.unsubscribe();
    this.subscriptionPas.unsubscribe();
  }

  ngOnInit(): void {

    this.form = this.formBuilder.group({
      search: [''],     
    });

    this.subscription = this.tourservice.paqueteConfirmado.subscribe(result => {
      this.idPaquete = result;
    });

    this.subscriptionAg = this.tourservice.agenciaConfirmada.subscribe(result => {
      this.idAgencia = result;
    });

    this.subscriptionPas = this.tourservice.paqueteConfirmadoPasajero.subscribe(result => {
      this.idPaquetePasajero = result;
    });

    this.agenciasTour()
  }

  verPlanilla(id_pasajero) {
    this.idPasajero = id_pasajero;
    this.tourservice.changePasajeroCfmId(id_pasajero);
    console.log("el pasajero que se toco es:  "+id_pasajero);
    
    this.router.navigate(['/admin/pasajero-confirmado']);
  }

  agenciasTour(){  
    this.listaReservaciones = [];
    this.agenciasService.agenciasTour(this.idAgencia, this.idPaquetePasajero).subscribe(data => {
      if(data instanceof HttpResponse) {
        if(data.body !== null && data.body !== undefined && data.body !== ''){
          //console.log(data.body);
          this.cantidadReservaciones = data.body.length;
          this.listaReservaciones = data.body;
          this.agenciaDatos =  this.listaReservaciones[0].id_agencia;
          this.idReservacion = this.listaReservaciones[0].id;
        }
        this.listaReservaciones.forEach(reservacion => {
          var pass = reservacion.pasajeros;
          pass.forEach(pasajero => {
            this.listapasajeros.push(pasajero);
          });
        });
        this.filtered = this.listapasajeros;

        //console.log("cantidad de reservaciones:  " + this.cantidadReservaciones);
        //console.log("la agencia es:  " + this.agenciaDatos);  
        //console.log("la reservacion es:  " + this.idReservacion);     
        //console.log(this.listaReservaciones);   
        //console.log(this.listapasajeros); 
      }    
    });    
  }

  onSubmit() { 
    var value = this.f.search.value;
    var recibido = [];
    if(value === ''){
      this.redirectTo(this.router.url); 
    }else {
      recibido = this.listapasajeros.filter(pass => 
        pass.numero_documento == value); 
      if(recibido.length === 0) {
        recibido = this.listapasajeros.filter(pass => 
          pass.nombre_pasajero === value); 
      } 
      this.filtered = recibido;
      //console.log(this.filtered);
    }
  }
  
  redirectTo(uri) {
    this.router.navigateByUrl('/', {skipLocationChange: true}).then(() =>
    this.router.navigate([uri]));
  }

  get f() { 
    return this.form.controls; 
  }

  darBaja(pasajeroId){
    const modalRef = this.modalService.open(ModalConfirmPasajeroDeleteComponent, { 
      centered: true,  
      backdrop:'static',      
    });
    modalRef.componentInstance.id = pasajeroId;
      
  }

}
